import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { Audit, AuditModel, AuditResponseModel } from 'src/app/models/login/audit.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.css']
})
export class AuditComponent implements OnInit {
  Loader: boolean = false;
  userData: any =[];
  audit: AuditModel;
  auditResponseModelTotalLength:any;
  auditData:any;
  pagingModel: PagingModel;
  selectedFilter: string;
  userSelected: Array<string> = [];
  totalPages: number;
  userList: Array<AuditModel>;
  maxDate: any = new Date();
  startDate: any = "";
  endDate: any = "";
  showStartDateError: boolean = false;
  showEndDateError: boolean = false;
  pageNumber: number = 1;
  userValues: string = "";
  selectedRole: string = "";
  auditResponseModel: AuditResponseModel;

  constructor(private localstorage:LocalstorageService, private alertify: AlertifyService, private router:Router, private _userService: UserService) 
  { 
    this.localstorage.setMenu("3");
    this.audit = new AuditModel();
    this.userList = new Array<AuditModel>();
    this.pagingModel = new PagingModel();
    this.auditResponseModel = new AuditResponseModel();
    this.pagingModel.pageNumber=1;
    if (this.totalPages == 0 || this.totalPages == undefined) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.getUserList();
    this.getAuditList();
  }

  onDateChange() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
  }

  onEndDateChange() {
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
  }

  onChangeFilter(value) {
    this.selectedFilter = value;
  }
  getUserList() {
    this._userService.userlist().subscribe(response => {
    var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.userData = responseBody.responseData;
      }
    });
  }

  selectRole(selectedUser) {
    if (selectedUser != "" && selectedUser != undefined && selectedUser != null) {
      var userFound = this.userData.filter((user) => {
        if(user.userId == selectedUser){
          return user.userId.toString();
        }
      });
      if(userFound.length > 0){
        this.userSelected.push(userFound[0].userId.toString());
      }
    }
  }

  resetFilter() {
    this.startDate = "";
    this.endDate = "";
    this.userSelected = [];
    this.userData = [];
    this.userValues = "";
    this.audit.PageNumber = 1;
    this.audit.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.getAuditList();
    this.getUserList();
  }

  filter() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
    this.audit.PageNumber = 1;
    this.audit.PageSize = 10;
    this.audit.StartDate = this.startDate;
    this.audit.EndDate = this.endDate;
    this.audit.UserId = this.userSelected.join(",");
    this.getAuditList();
  }

  getAuditList() {
    this.Loader = true;
    this.audit.StartDate = this.startDate;
    this.audit.EndDate = this.endDate;
    this.audit.UserId = this.userSelected.join(",");
    this._userService.audit(this.audit).subscribe(response => {
      this.Loader = false;
       this.auditData = JSON.parse(response._body);
      if(this.auditData.isSuccess)
      {
        this.auditResponseModelTotalLength = this.auditData && this.auditData.responseData && this.auditData.responseData.length>0 ? this.auditData.responseData.length:0;
        this.auditResponseModel.AuditList = this.auditData.responseData;
        this.auditResponseModel.TotalPages = this.auditData.totalPages;
        this.totalPages = this.auditResponseModel.TotalPages == undefined ? 0 : this.auditResponseModel.TotalPages;
      } else {
        this.alertify.error(this.auditData.responseMessage);
        this.Loader = false;
      }
    });
  }

  loadPage(pagingModel: PagingModel) {
    this.audit.PageNumber = pagingModel.pageNumber;
    this.audit.PageSize = pagingModel.pageSize;
    this.getAuditList();
  }
}
